module.exports = __webpack_public_path__ + "img/wrong_icon.48ced478.svg";